//@flow

import React, { Fragment } from 'react';
import { RadioGroup, Radio } from 'react-radio-group';
import { Label, InputGroup, Input, FormGroup, Button } from 'reactstrap';

import Counter from '../../components/Counter';
import { isBrowser } from '../../lib/utils';
import getNextMonthsWithYears, { activeClassNameFor } from './helpers';

import '../../../node_modules/flatpickr/dist/themes/airbnb.css';

let Flatpickr = '';
if (isBrowser()) Flatpickr = require('react-flatpickr').default;

type openInputFieldProps = {
  duration: number,
  month: string,
  dispatch: Function,
};

type Props = {
  groupSize: number,
  dateRange: Array<String>,
  selectedDateCondition: string,
  disabled: boolean,
  userHasStartDate: boolean,
  dispatch: Function,
  ...openInputFields,
};

const PickDateConditions = [
  { value: 'datePickr', text: 'I have my exact travel dates' },
  { value: 'monthPickrAndApproxDuration', text: 'I have approximate dates' },
  { value: 'approxDuration', text: 'I don\'t have my dates yet' },
];

export default function TravelStyle(props: Props) {
  const { dispatch, groupSize, selectedDateCondition, disabled, userHasStartDate } = props;

  return (
    <Fragment>
      <div className="group-size">
        <h3 className="onboard-title mb-4">Number of travellers?</h3>

        <Counter
          value={groupSize}
          onChange={v => dispatch({ type: 'CHANGE', groupSize: v })}
        />
      </div>
      <div className="travel-dates">
        {!userHasStartDate ? (
          <Fragment>
            <h3 className="onboard-title mb-4">When will you be travelling?</h3>
            <RadioGroup
              className="travel-dates-options"
              selectedValue={selectedDateCondition}
              onChange={value => dispatch({ type: 'CHANGE', selectedDateCondition: value })}
            >
              <ul>
                {PickDateConditions.map(({ value, text }) => (
                  <li key={value}>
                    <Label
                      className={`btn btn-onboard-radio ${activeClassNameFor(
                        selectedDateCondition,
                        value
                      )}`}
                    >
                      <Radio value={value} />
                      {text}
                    </Label>
                  </li>
                ))}
              </ul>
            </RadioGroup>
            <div className="travel-dates-options">
              {openInputFields(selectedDateCondition, props)}
            </div>
          </Fragment>
        ) : null}

        <div className="text-center">
          {!disabled && (
            <Button
              color="yellow"
              onClick={() => dispatch({ type: 'INCREMENT', key: 'step' })}
            >
              Next
            </Button>
          )}
        </div>
      </div>
    </Fragment>
  );
}

function openInputFields(show: string, props: openInputFieldProps) {
  const { duration, month, dispatch } = props;
  const nextYearsWithMonths = getNextMonthsWithYears(12);

  const ApproxDurationComponent = (
    <Counter
      title="Approx. Duration"
      value={duration}
      onChange={v => dispatch({ type: 'CHANGE', duration: v })}
    />
  );

  if (show === 'datePickr') {
    return (
      <Fragment>
        <div>Trek Dates</div>
        <FormGroup>
          <InputGroup>
            <Flatpickr
              id="flatpickr"
              options={{
                mode: 'range',
                minDate: 'today',
                disableMobile: 'true',
                altInput: true,
                altFormat: 'F j, Y',
              }}
              onClose={date => dispatch({ type: 'CHANGE', dateRange: date })}
              className="form-control datepicker"
              placeholder="Select your dates"
            />
          </InputGroup>
        </FormGroup>
      </Fragment>
    );
  }

  if (show === 'monthPickrAndApproxDuration') {
    return (
      <div>
        <FormGroup>
          <Label for="exampleSelect">Select a month</Label>
          <Input
            type="select"
            name="select"
            value={month}
            onChange={e => dispatch({ type: 'CHANGE', month: e.target.value })}
          >
            {nextYearsWithMonths.map(monthWithYear => (
              <option key={monthWithYear}>{monthWithYear}</option>
            ))}
          </Input>
        </FormGroup>
        {ApproxDurationComponent}
      </div>
    );
  }

  if (show === 'approxDuration') {
    return <Fragment>{ApproxDurationComponent}</Fragment>;
  }
}



// WEBPACK FOOTER //
// ./src/screens/OnboardingForm/TravelStyle.jsx